
export default {
  name: 'ProgramPlug',
  props: {
    selectedBookmarkTab: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list.program-plug'
    }
  }
}
